export const getDefaultState = () => {
  return {
    orderDetail: null,
    bs_myp_05_040: null,
    cancelNo: null
  }
}

export const initState = () => {
  // 事前決済 決済GW遷移時用の処理
  const orderDetail = JSON.parse(sessionStorage.getItem('advancePaymentOrderDetail'))
  if(orderDetail){
    sessionStorage.removeItem('advancePaymentOrderDetail')
    return {
      orderDetail: orderDetail,
      bs_myp_05_040: null,
      cancelNo: null
    }
  }
  else{
    return getDefaultState()
  }
}

const state = initState()
export default state
